import { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { LoaderCircle } from 'lucide-react';

import { config, callApi } from './NetUtils';
import CompanyProfile from './CompanyProfile';

const CompanyPage = () => {
    const { companyName } = useParams();
    const [company, setCompany] = useState(null);
    const [reports, setReports] = useState([]);
    const [lastEvaluatedKey, setLastEvaluatedKey] = useState(null);
    const [loading, setLoading] = useState(true);
    const [loadingMore, setLoadingMore] = useState(false);
    const [error, setError] = useState(null);

    const fetchCompanyData = async (key = null) => {
        if (!key) setLoading(true); else setLoadingMore(true);

        if (navigator.onLine) {
            const endpoint = `/reports/${encodeURIComponent(companyName)}${key ? `?lastEvaluatedKey=${encodeURIComponent(JSON.stringify(key))}` : ''}`;
            const response = await callApi(config.DATA_API_URL, endpoint);

            if (response.success) {
                if (response.data.companyDetails) {
                    setCompany(response.data.companyDetails);
                }
                setReports(prev => key ? [...prev, ...response.data.reportsPage.items] : response.data.reportsPage.items);
                setLastEvaluatedKey(response.data.reportsPage.lastEvaluatedKey);
                if (!key) setError(null);
            } else {
                setError(response.error);
            }
                } else {
                        // Try localStorage via helper
                        try {
                            const { getJSON } = await import('./localStorageUtils');
                            const parsed = getJSON(`reports_${companyName}`, null);
                            if (parsed) {
                                setCompany(parsed.companyDetails);
                                setReports(parsed.reportsPage.items);
                            } else {
                                setError("No network and no cached data available.");
                            }
                        } catch (e) {
                            setError("No network and no cached data available.");
                        }
        }

        if (!key) setLoading(false); else setLoadingMore(false);
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => { fetchCompanyData(); }, [companyName]);

    if (loading) return <div className="flex justify-center"><LoaderCircle className="w-12 h-12 animate-spin text-blue-600" /></div>;
    if (error) return <div className="text-center p-4 bg-red-100 text-red-700 rounded-lg"><h3 className="font-bold">Ouch</h3><p>{error}</p></div>;
    if (!company) return <p className="text-center">Company not found.</p>;

    return <CompanyProfile
        company={company}
        reports={reports}
        lastEvaluatedKey={lastEvaluatedKey}
        loadingMore={loadingMore}
        fetchMore={() => fetchCompanyData(lastEvaluatedKey)}
        fetchCompanyData={fetchCompanyData} />;
};

export default CompanyPage;